import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

export default function TabPanelWizard(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      <Box>
        {children}
      </Box>
    </div>
  );
}

TabPanelWizard.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
